import IcmsService from "../../../../services/IcmsService.js";
import AuditoriaService from "../../../../services/AuditoriaService.js";

export default class ApiService {
  constructor(messages) {
    this.messages = messages;
  }

  async getNotes(query) {
    try {
      const { data } = await IcmsService.getDifferentialAliquotNotes(query);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possivel buscar notas!"),
      );
    }
  }

  async getItemsXML(query) {
    try {
      const { data } = await IcmsService.getDifferentialAliquotItems(query);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Erro ao buscar produtos da XML."),
      );
    }
  }

  async getSubstituicao(fts) {
    try {
      const { body } = await IcmsService.getSubstituicao(fts, 0);
      return body.data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a busca de Itens Substituição."),
      );
    }
  }

  async getIsentos(fts) {
    try {
      const { data } = await IcmsService.getIsentosByNcm(fts);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a busca de Itens Isentos."),
      );
    }
  }

  async insertReference({
    idEmpresa,
    cpfCnpj,
    cProd,
    xProd,
    itemSubstituicao,
    itemTributado,
    itemIsento,
    aliqReducao,
  }) {
    try {
      const payload = {
        idEmpresa,
        cpfCnpj,
        cProd,
        xProd,
        itemIsento,
        itemSubstituicao,
        itemTributado,
        aliqReducao,
      };
      await IcmsService.insertDifferentialAliquotReference(payload);
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a referenciação."),
      );
    }
  }

  async deleteReference(param) {
    try {
      await IcmsService.deleteDifferentialAliquotReference(param);
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível remover a referenciação."),
      );
    }
  }

  async getCalc({
    idEmpresa,
    cpfCnpj,
    cProd,
    xProd,
    idItem,
    idNfe,
    vlItem,
    vlBcIcms,
    aliqIcms,
    vlIcms,
    vlSt,
    aliqOrigem,
    aliqDestino,
    aliqDifal,
  }) {
    try {
      const query = {
        idEmpresa,
        cpfCnpj,
        cProd,
        xProd,
        idNfe,
        idProd: idItem,
        vlLiquido: vlItem,
        vlBcIcms,
        aliqIcms,
        vlIcms,
        vlSt,
        aliqOrigem,
        aliqDestino,
        aliqDifal,
      };
      const { data: [data] = {} } =
        await AuditoriaService.calcDiffAliquot(query);
      if (!data) return {};
      return {
        cProd,
        idItem,
        pDifal: parseFloat(data.pDifal),
        vBcDifal: parseFloat(data.vBcDifal),
        vDifal: parseFloat(data.vDifal),
      };
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar o cálculo."),
      );
    }
  }

  async insertStApured(param) {
    try {
      const { data } = await AuditoriaService.insertStApured(param);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar o calculo."),
      );
    }
  }

  async resetVlIcmsItem(param) {
    try {
      const { data } = await AuditoriaService.resetVlIcmsItem(param);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível resetar o icms do item."),
      );
    }
  }
}
